import { get } from 'lodash';

const root = state => get(state, 'UtilitiesState.updateOpenOrders');

export const getOpenOrderDetailData = state =>
  get(root(state), 'openOrderDetailData', []);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getUpdateOrderResponseError = state =>
  get(root(state), 'updateOrderResponseError', null);
export const getSiteGroup = state => get(root(state), 'siteGroupData', []);
export const getWarehouseKitchen = state =>
  get(root(state), 'warehouseKitchenData', []);
export const getSiteGroupError = state =>
  get(root(state), 'fetchingSiteGroupError', null);
export const getWarehouseKitchenDataError = state =>
  get(root(state), 'warehouseKitchenDataError', null);
export const getItemListError = state =>
  get(root(state), 'itemListError', null);
export const getItemListData = state => get(root(state), 'itemList', []);
export const getLoadingStatus = state => get(root(state), 'loading', false);
export const getIsFetchingItemList = state =>
  get(root(state), 'isFetchingItemList', false);
export const getIsFetchingSiteGroup = state =>
  get(root(state), 'isFetchingSiteGroup', false);
export const getSubmitting = state => get(root(state), 'submitting', false);
export const getTotalPrimary = state => get(root(state), 'totalPrimary', 0);
export const getTotalSecondary = state => get(root(state), 'totalSecondary', 0);
export const geTotalRemaining = state => get(root(state), 'totalRemaining', 0);
export const getWarehouseAvlbQuantity = state =>
  get(root(state), 'WarehouseAvlbQuantity', 0);
export const getIsTotalExceed = state =>
  get(root(state), 'isTotalExceed', false);
export const getKitchenData = state => get(root(state), 'kitchenData', []);



// WEBPACK FOOTER //
// ./src/pages/utilities/state/updateopenorders/selectors.js